/** 来源：三家输入控件；用主题 token 统一高度、颜色、焦点环和圆角。 */
export const controlClasses = 'min-h-[var(--control-height)] rounded-[var(--radius-md)] border border-[var(--color-line)] bg-[var(--color-panel)] px-3 py-1.5 text-sm text-[var(--color-ink)] placeholder:text-[var(--color-placeholder)] focus:border-[var(--color-primary)] focus:outline-none focus:ring-[3px] focus:ring-[var(--color-focus)] disabled:cursor-not-allowed disabled:opacity-50'

const widthClassPattern = /(?:^|\s)!?(?:w-|max-w-|min-w-)/
const errorClasses = 'border-[var(--color-danger)] focus:border-[var(--color-danger)] focus:ring-[var(--color-danger-soft)]'

/** 调用方给了宽度类则不再内建 w-full，避免 FilterBar 的 w-40 被同层 w-full 盖掉。 */
export function controlClassName(className = '', error = false): string {
  const width = widthClassPattern.test(className) ? '' : 'w-full'
  return `${width} ${controlClasses} ${error ? errorClasses : ''} ${className}`.trim()
}
